import IcoMoon from "react-icomoon";
const iconSet = require("./selection.json");

const Icon = ({ ...props }) => {
  //   console.log(props, iconList(iconSet));
  return <IcoMoon icon={props.icon} iconSet={iconSet} {...props} />;
};

export default Icon;
